/* eslint-disable semi */
/* eslint-disable quotes */
// import defaultSettings from '@/settings'

const title = "송파구시설관리공단";

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${title}`;
  }
  return `${title}`;
}
